import { FunctionComponent } from 'react';
import '../shared/sub-menu/sub-menu.scss';
import SubMenuItem from '../shared/sub-menu/sub-menu-item';

export type ShowcasesMenuItems =
  | 'showcases/businessintelligence'
  | 'showcases/marketresearch'
  | 'showcases/healthcare'
  | 'showcases/politics'
  | 'showcases/finance'
  | 'showcases/productquality'
  | 'showcases/education'
  | 'showcases/municipaladministration';

export type Languages = 'de' | 'en';

export type Props = {
  selected?: ShowcasesMenuItems;
};

const ShowcasesMenu: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <div className="sub-menu-wrapper showcase-menu">
      <div className="sub-menu">
        <ul>
          {/* ===================================================================== */}
          <SubMenuItem
            selected={props.selected}
            menuName={'showcases/businessintelligence'}
            labels={[
              { language: 'de', label: 'Business Intelligence' },
              { language: 'en', label: 'Business Intelligence' },
            ]}
          />

          {/* ================================================================= */}
          <SubMenuItem
            selected={props.selected}
            menuName={'showcases/marketresearch'}
            labels={[
              { language: 'de', label: 'Markt-forschung' },
              { language: 'en', label: 'Market Research' },
            ]}
          />

          {/* ================================================================ */}
          <SubMenuItem
            selected={props.selected}
            menuName={'showcases/healthcare'}
            labels={[
              { language: 'de', label: 'Gesundheits-wesen' },
              { language: 'en', label: 'Healthcare' },
            ]}
          />

          {/* =================================================================== */}
          <SubMenuItem
            selected={props.selected}
            menuName={'showcases/politics'}
            labels={[
              { language: 'de', label: 'Politik' },
              { language: 'en', label: 'Politics' },
            ]}
          />

          {/* ================================================================ */}
          <SubMenuItem
            selected={props.selected}
            menuName={'showcases/finance'}
            labels={[
              { language: 'de', label: 'Finanzwesen' },
              { language: 'en', label: 'Finance' },
            ]}
          />
          {/* ========================================================================== */}
          <SubMenuItem
            selected={props.selected}
            menuName={'showcases/productquality'}
            labels={[
              { language: 'de', label: 'Produkt & Qualitäts-managemnt' },
              { language: 'en', label: 'product quality management' },
            ]}
          />
          {/* ===================================================================== */}
          <SubMenuItem
            selected={props.selected}
            menuName={'showcases/education'}
            labels={[
              { language: 'de', label: 'Bildung' },
              { language: 'en', label: 'Education' },
            ]}
          />
          {/* ===================================================================== */}
          <SubMenuItem
            selected={props.selected}
            menuName={'showcases/municipaladministration'}
            labels={[
              { language: 'de', label: 'Kommunale Verwaltung' },
              { language: 'en', label: 'Municipal Administration' },
            ]}
          />
        </ul>
      </div>
    </div>
  );
};

export default ShowcasesMenu;
